<template lang="pug">
.plan-change-detail-modal
  b-modal(ref="modal" size="xl" no-close-on-backdrop no-close-on-esc hide-footer scrollable)
    template(#modal-header="{ cancel }")
      .plan-change-detail-modal-header
        span プラン変更の反映と請求について
      button.close(type="button" @click="cancel") ×

    .plan-change-detail-modal-body
      ul.detail-text
        li プラン変更はお客様がプラン変更処理を行った日から適用されます。
        li プラン変更が行われた場合、その翌月より変更後のプランに係る本サービスの料金が適用されます。
        li ご請求書はご利用翌月１０日頃までに発行いたします。利用料のお支払期限はご利用翌々月末になります。
      .case
        .title 契約プランの変更例①：4/15にライト20プランからベーシック20プランに変更した場合
        b-img(src="@/assets/plan-change-01.png" fluid)
      .case
        .title 契約プランの変更例②：4/15にベーシック20プランからライト20プランに変更した場合
        b-img(src="@/assets/plan-change-02.png" fluid)
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

/**
 * プラン変更詳細モーダル
 */
@Component
export default class PlanChangeDetailModal extends Vue {
  /**
   * モーダル表示
   */
  public show(): void {
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }
}
</script>
